import type { ThemeConfig } from 'antd';
import { theme as AntdTheme } from 'antd';

const internalDarkTokens = {
  bgPage: '#0f1113',
  bgSidebar: '#09090b',
  bgPanel: '#111113',
  bgPopover: '#18181b',
  bgInput: '#09090b',
  textPrimary: 'rgba(255, 255, 255, 0.94)',
  textSecondary: 'rgba(255, 255, 255, 0.68)',
  textMuted: 'rgba(255, 255, 255, 0.46)',
  textPlaceholder: 'rgba(255, 255, 255, 0.36)',
  border: 'rgba(255, 255, 255, 0.11)',
  borderSubtle: 'rgba(255, 255, 255, 0.08)',
  accent: '#8B5CF6',
  accentLegacy: '#4931FA',
  accentSoft: 'rgba(139, 92, 246, 0.18)',
  accentSofter: 'rgba(139, 92, 246, 0.1)',
  accentSelected: '#ddd6fe',
  danger: '#FD795B',
  shadowCard: '0 12px 36px rgba(0, 0, 0, 0.34)',
  shadowPanel: '0 20px 60px rgba(0, 0, 0, 0.42)',
} as const;

const theme: ThemeConfig = {
  algorithm: [AntdTheme.darkAlgorithm],

  components: {
    Layout: {
      colorBgHeader: internalDarkTokens.bgSidebar,
      colorBgBody: internalDarkTokens.bgPage,
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Menu: {
      itemSelectedBg: internalDarkTokens.accentSoft,
      itemBg: internalDarkTokens.bgPanel,
      itemActiveBg: internalDarkTokens.accentSofter,
      itemHoverBg: 'rgba(255, 255, 255, 0.06)',
      itemColor: internalDarkTokens.textSecondary,
      itemHoverColor: internalDarkTokens.textPrimary,
      itemSelectedColor: internalDarkTokens.accentSelected,
      itemHeight: 36,
    },
    Input: {
      colorBgContainer: internalDarkTokens.bgInput,
      colorBorder: internalDarkTokens.border,
      colorText: internalDarkTokens.textPrimary,
      colorTextPlaceholder: internalDarkTokens.textPlaceholder,
      errorActiveShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
    },
    Select: {
      // v1.0
      optionFontSize: 15,

      colorBgContainer: internalDarkTokens.bgInput,
      colorBgElevated: internalDarkTokens.bgPopover,
      colorBorder: internalDarkTokens.border,
      colorText: internalDarkTokens.textPrimary,
      colorTextPlaceholder: internalDarkTokens.textPlaceholder,
      controlItemBgActive: internalDarkTokens.accentSoft,
      multipleItemBg: internalDarkTokens.accentSoft,
      optionSelectedBg: internalDarkTokens.accentSoft,
    },
    Radio: {},
    Switch: {
      colorPrimary: internalDarkTokens.accentLegacy,
      colorPrimaryHover: internalDarkTokens.accentLegacy,
    },
    Message: {},
    Modal: {},
    Popconfirm: {},
    Slider: {},
    Upload: {},
    InputNumber: {
      colorBgContainer: internalDarkTokens.bgInput,
      paddingInline: 8,
      handleBorderColor: internalDarkTokens.border,
      colorText: internalDarkTokens.textPrimary,
      handleBg: internalDarkTokens.bgPopover,
      controlWidth: 85,
    },
  },

  token: {
    // Seed Token，影响范围大
    colorPrimary: internalDarkTokens.accent,
    borderRadius: 8,
    // 派生变量，影响范围小
    colorBgBase: internalDarkTokens.bgPage,
    colorBgContainer: internalDarkTokens.bgPanel,
    colorBgElevated: internalDarkTokens.bgPopover,
    colorTextBase: internalDarkTokens.textPrimary,
    colorText: internalDarkTokens.textPrimary,
    colorTextSecondary: internalDarkTokens.textSecondary,
    colorTextTertiary: internalDarkTokens.textMuted,
    colorBorder: internalDarkTokens.border,
    colorBorderSecondary: internalDarkTokens.borderSubtle,
    colorPrimaryBg: internalDarkTokens.accentSoft,
    // colorLink: '#FE4854',
    // colorSplit: '#53536B',
    colorError: internalDarkTokens.danger,
    lineWidth: 0.5,
    opacityLoading: 0.5,
    boxShadow: internalDarkTokens.shadowCard,
    boxShadowSecondary: internalDarkTokens.shadowPanel,
  },
};

export default theme;
